/* =====================================================
   EUMEMO
   AJUSTES PERSONALIZADOS
===================================================== */


/* =====================================================
   AVISO DE FRETE GRÁTIS NO CARRINHO
===================================================== */

function adicionarAvisoFrete() {

  const barraBrindes = document.querySelector(
    '#shipping-container-cart_drawer'
  );

  if (!barraBrindes) return;

  if (document.querySelector('.eumemo-aviso-frete')) return;

  const aviso = document.createElement('div');

  aviso.className = 'eumemo-aviso-frete';

  aviso.style.cssText = `
    width: calc(100% - 40px);
    margin: 0px auto 0px;
    padding: 9px 12px;
    background: #F7F7F7;
    border-radius: 7px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    font-size: 13px;
    line-height: 1.2;
    color: #202223;
    box-sizing: border-box;
  `;

  aviso.innerHTML = `
    <span class="eumemo-truck">🚚</span>
    <span>
      Frete grátis a partir de
      <strong style="font-weight:700; color:#000000;">
        R$ 269,00
      </strong>
    </span>
  `;

  barraBrindes.insertAdjacentElement(
    'afterend',
    aviso
  );
}


/* =====================================================
   HEADER DO CARRINHO
===================================================== */

function compactarHeaderCarrinho() {

  const drawer = document.querySelector('cart-drawer');

  if (!drawer) return;

  const header = drawer.querySelector('.drawer__header');

  if (!header) return;

  header.style.setProperty(
    'min-height',
    '0',
    'important'
  );

  header.style.setProperty(
    'height',
    'auto',
    'important'
  );

  header.style.setProperty(
    'padding-top',
    '12px',
    'important'
  );

  header.style.setProperty(
    'padding-bottom',
    '12px',
    'important'
  );
}


/* =====================================================
   APROXIMAR PRODUTOS DO FRETE
===================================================== */

function aproximarProdutosDoFrete() {

  const listas = document.querySelectorAll(
    '.horizontal-products'
  );

  listas.forEach((lista) => {

    lista.style.setProperty(
      'margin-top',
      '-16px',
      'important'
    );

  });
}


/* =====================================================
   LINHA ENTRE FRETE E PRODUTOS
===================================================== */

function adicionarDivisorFrete() {

  if (
    document.getElementById(
      'eumemo-divisor-frete-style'
    )
  ) return;

  const style = document.createElement('style');

  style.id = 'eumemo-divisor-frete-style';

  style.textContent = `

    .eumemo-aviso-frete {
      position: relative !important;
      margin-bottom: 16px !important;
    }

    .eumemo-aviso-frete::after {
      content: "" !important;
      position: absolute !important;
      left: 0 !important;
      right: 0 !important;
      bottom: -16px !important;
      height: 1px !important;
      background: #E5E5E5 !important;
      display: block !important;
    }

  `;

  document.head.appendChild(style);
}


/* =====================================================
   ESTILO DAS CORES NOS CARDS DA COLEÇÃO

   MOBILE:
   - BOLINHAS 20PX

   DESKTOP:
   - BOLINHAS 24PX
===================================================== */

function estiloSwatchesCardsEumemo() {

  if (
    document.getElementById(
      'eumemo-estilo-swatches-cards'
    )
  ) return;

  const style = document.createElement('style');

  style.id = 'eumemo-estilo-swatches-cards';

  style.textContent = `

    /* ==========================================
       MOBILE
    ========================================== */

    .product-card__bottom .swatches {
      overflow: visible !important;
      margin-top: 0 !important;
    }


    /* BOLINHAS MOBILE */

    .product-card__bottom .color-swatch {

      --swatch-size: 20px !important;

      width: 20px !important;
      height: 20px !important;

      min-width: 20px !important;
      min-height: 20px !important;

    }


    /* ==========================================
       DESKTOP
    ========================================== */

    @media screen and (min-width: 750px) {

      .product-card__bottom .swatches {
        margin-top: 0 !important;
      }


      /* BOLINHAS MAIORES NO DESKTOP */

      .product-card__bottom .color-swatch {

        --swatch-size: 24px !important;

        width: 24px !important;
        height: 24px !important;

        min-width: 24px !important;
        min-height: 24px !important;

        flex: 0 0 24px !important;

      }

    }

  `;

  document.head.appendChild(style);
}


/* =====================================================
   EXECUTA TODOS OS AJUSTES
===================================================== */

function executarAjustesEumemo() {

  adicionarAvisoFrete();

  compactarHeaderCarrinho();

  aproximarProdutosDoFrete();

  adicionarDivisorFrete();

  estiloSwatchesCardsEumemo();

}


/* =====================================================
   EXECUTA AO CARREGAR A PÁGINA
===================================================== */

if (document.readyState === 'loading') {

  document.addEventListener(
    'DOMContentLoaded',
    executarAjustesEumemo
  );

} else {

  executarAjustesEumemo();

}


/* =====================================================
   OBSERVA ALTERAÇÕES DO TEMA / CARRINHO / COLEÇÃO
===================================================== */

const observerEumemo = new MutationObserver(() => {

  executarAjustesEumemo();

});

observerEumemo.observe(document.body, {
  childList: true,
  subtree: true
});